/**
 * GroupGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { GroupData } from './group_data'

/**
 * GroupGetRes
 */
export interface GroupGetRes {
  /** 群组详情 */
  items?: GroupData[]
}

/**
 * GroupGetRes Schema
 */
export const GroupGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '群组详情',
      format: '[]*model.GroupData',
      items: { $ref: 'GroupData', description: '' },
      type: 'array',
      label: '群组详情',
    },
  },
  type: 'object',
}
